import React from 'react';
import '../template-file-css/document-file-template.css';


export const JHC_AdultClientAbuse = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='JHC_AdultClientAbuse' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <b> <center> Client Abuse and/or Neglect </center> </b>
                </p>
                <p className='w-750'>
                    Criminal statute L.S.A.-R.S.14:403 specifies that any person in the Children's Code who is required to report abuse or neglect, including sexual abuse of a child under age 18, is to report information to authorities when that person has cause to believe a child's physical or mental health or welfare is endangered. Willful and knowing failure to report can result in $500.00 fine or imprisonment for six (6) months, or both.
                </p>
                <p className='w-750'>
                    La. Children's Code Art. 603 defines those persons who must report child abuse as mandatory reporters, which include: any person who provides health care services, e.g., doctors, nurses, technicians; mental health or social services professionals who provide counseling services to a child or his/her family; members of the clergy; teaching or child care providers; law enforcement officers and commercial film processors.
                </p>
                <p className='w-750'>
                    Art. 603 (13) (c) provides an exception to the mandatory reporting requirement for a "Member of the clergy." He is not required to report a confidential communication, i.e., "one made privately and not intended for further disclosure except to the persons present in furtherance of the communication from a person," if the member of the clergy, in the course of the discipline or practice of that church, denomination, or organization, is authorized or accustomed to hearing confidential communications, and under the discipline or tenets of the church, denomination, or organization has a duty to keep such communications confidential. In that instance, the member of the clergy shall encourage that person to report the allegations to the appropriate authorities.
                </p>
                <p className='w-750'>
                    Art. 610 is the reporting procedure that requires mandatory reporters to immediately report to local child protection unit of Department of Social Services in cases where the abuser is believed to be a parent, caretaker, a person who maintains an interpersonal dating or engagement relationship with the parent or caretaker, or a person living in the same residence with the parent or caretaker as spouse whether married or not. If such a person or caretaker is not believed to have any responsibility for the abuse or neglect, the report should be immediately made to the appropriate local or state law enforcement agency. Dual reporting shall be permitted. The initial report may be verbal, and should contain the following information, if known:
                    <ol>
                        <li>Name, address, age, sex and race of the child;</li>
                        <li>Nature, extent and cause of child's injuries or endangered condition, including any previous known or suspected abuse to the child or child's siblings;</li>
                        <li>Name and address of parent(s) or caretaker;</li>
                        <li>Names and ages of all other members of child's household;</li>
                        <li>Name and address of the reporter;</li>
                        <li>Account of how child came to reporter's attention;</li>
                        <li>Explanation of cause of child's injury or condition offered by child, the caretaker  or any other person;</li>
                        <li>Any other information which the reporter believes might be important or relevant. </li>

                    </ol>
                </p>

                <p className='w-750'>
                    If the initial report is verbal, it shall be followed by a written report within five (5) days to the appropriate agency, i.e., local child protection unit or law enforcement agency.

                </p>
                <p className='w-750'>
                    Article 611grants immunity from civil or criminal liability to any reporter, for the making of any report in good faith, and without knowledge of the falsity of such information, or reckless disregard for the truth of the report.
                </p>
                <p className='w-750'>
                    The Directors and staff of Jackson Hands of Change, LLC. will be responsible for reporting suspected abuse and/or neglect to the appropriate state agencies. Jackson Hands of Change, LLC  will follow all state laws in the referral of minor patients to the appropriate child protection agency. All cases will be documented in the client's chart. The telephone number for reporting suspected child abuse or neglect is:
                    <b>
                        <center>1-855-452-5437</center>
                    </b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader' >Abuse is defined as any of the following:</span>
                    <b>Physical abuse:</b> Assault or battery of a consumer, unnecessary force, unjustified restraint, or sexual touching of a consumer.
                    <br />
                    <b>Emotional/Verbal Abuse or Humiliation:</b> Insulting language to a consumer, verbal threats, inappropriate sexual comments or behavior toward privacy, emotional exploitation of nay kind.
                    <br />
                    <b>Neglect: </b>Withholding prescribed treatment or care without justification, denying the consumer any right identified in the consumer's rights policy, and or:
                    <br />
                    <b>Financial Exploitation:</b> Any exploitation of a person for financial gain.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Print  Client Name </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Agency Representative </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Client, Guardian or Personal Representative  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}